//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// sudo-delete-everything imports
import { IContainer, IProps, IState } from "./SudoDeleteEverything.d";
import { sudoDeleteEverythingFragments } from "./SudoDeleteEverything.gql";
import { styles as sudoStyles } from "@components/sudo-wrapper/SudoWrapper.styles";
import { styles } from "./SudoDeleteEverything.styles";
// state
import { IReduxState } from "@reducers/root.reducer";
import { snackBarOpen } from "@actions/snack-bar.actions";
// util
import { windowLocation } from "@util/location.util";
// mutations
import { sudoDeleteEverything } from "@mutations";
// material-ui
import { Button, LinearProgress, Paper } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class SudoDeleteEverythingCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  private onSuccess = () => {
    this.props.snackBarOpen("Success! Deleted everything!");
    setTimeout(() => {
      windowLocation.assign("SudoDeleteEverythingSuccess", "/");
      this.setState({ loading: false });
    }, 1000);
  };

  private onFailure = () => {
    this.props.snackBarOpen("Failed to delete. :(");
    this.setState({ loading: false });
  };

  private onClick = () => {
    const confirm = window.confirm(
      "Are you sure you want to delete all data from this environment?",
    );
    if (!confirm) {
      return;
    }

    this.setState({ loading: true });
    sudoDeleteEverything(
      this.props.relay.environment,
      {},
      () => this.onSuccess(),
      () => this.onFailure(),
    );
  };

  public render() {
    const env = process.env.NODE_ENV;
    return (
      <Paper elevation={2} style={sudoStyles.paper}>
        <div style={sudoStyles.title}>Delete All Data</div>
        <div style={sudoStyles.instructions}>
          This allows you to reset all data on a particular environment. It will be permanently
          deleted, use with discretion. This is not available on production!
        </div>
        <div style={sudoStyles.row}>
          <Button
            variant="contained"
            color="primary"
            style={sudoStyles.btn}
            onClick={() => this.onClick()}
            disabled={this.state.loading}
          >
            Delete all data on {env}
          </Button>
        </div>
        {this.state.loading ? <LinearProgress variant="indeterminate" /> : null}
      </Paper>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const SudoDeleteEverythingStyled = withStyles(styles)(SudoDeleteEverythingCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const SudoDeleteEverythingRedux = connect(mapStateToProps, {
  snackBarOpen,
})(SudoDeleteEverythingStyled);

//////////////////
// RELAY
//////////////////
export const SudoDeleteEverything = createFragmentContainer<IContainer>(
  SudoDeleteEverythingRedux,
  sudoDeleteEverythingFragments,
);
